import React from 'react';
import './StructureInfo.css';
import api from '../../../api/axios.js';
import Tooltip from '../../Tooltip.js';

function StructureInfo({ selectedStructure, hasStructure }) {
    
    if (!hasStructure || !selectedStructure) {
        return (
            <div className="structure-info-container">
                <h3 className="structure-info-title">Structure Information</h3>
                <div className="structure-info-content">
                    <div className="info-item">
                        <span className="info-label">Status:</span>
                        <span className="info-value">Not available</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="structure-info-container">
            <h3 className="structure-info-title">Structure Information</h3>
            <div className="structure-info-content">
                {selectedStructure.pdb_id != null && (
                <div className="info-item">
                    <span className="info-label">PDB ID:</span>
                    <span className="info-value">{selectedStructure.pdb_id ?? "Not available"}</span>
                </div>
                )}
                <div className="info-item">
                    <span className="info-label">Type:</span>
                    <span className="info-value">{selectedStructure.type}</span>
                </div>
                {selectedStructure.form != null && (
                <div className="info-item">
                    <span className="info-label">Form:</span>
                    <span className="info-value">{selectedStructure.form}</span>
                </div>
                )}
                <div className="info-item">
                    <span className="info-label">Method:</span>
                    <span className="info-value">{selectedStructure.method}</span>
                </div>
                {selectedStructure.source_name && (
                <div className="info-item">
                    <span className="info-label">Structures set:</span>
                    <span className="info-value">
                        {selectedStructure.source_description ? (
                            <Tooltip content={selectedStructure.source_description}>
                                {selectedStructure.source_name}
                            </Tooltip>
                        ) : (
                            selectedStructure.source_name
                        )}
                    </span>
                </div>
                )}
                {selectedStructure.resolution != null && (
                    <div className="info-item">
                        <span className="info-label">Resolution:</span>
                        <span className="info-value">{`${selectedStructure.resolution} Å`}</span>
                    </div>
                )}
                {selectedStructure.date != null && (
                    <div className="info-item">
                        <span className="info-label">Date:</span>
                        <span className="info-value">{selectedStructure.date}</span>
                    </div>
                )}
            </div>
            <div className="structure-download-wrap">
                <a
                    href={`${api.defaults.baseURL}${selectedStructure.path}`}
                    download
                    className="structure-download-button"
                >
                    Download PDB
                </a>
            </div>
        </div>
    );
}

export default StructureInfo;